import { useTranslation } from "react-i18next";
import { Col, Form, Row, Spin} from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent, useEffect, useState } from "react";
import FormInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { get } from "lodash";
import { useWatch } from "antd/es/form/Form";



type FormCreateAcademicLevelProps = {
	form: FormInstance,
	onFinish?: any,
	dataOptions?: any,
	loadingForm: boolean,
}

const FormCreateAcademicLevel: FunctionComponent<FormCreateAcademicLevelProps> = ({ form, onFinish, dataOptions, loadingForm }) => {
  const { t } = useTranslation();

  const validations = {
	code: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Mã học vấn không vượt quá 512 ký tự", "Mã học vấn không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập mã học vấn", "Vui lòng nhập mã học vấn")))
			}
			return Promise.resolve()
		}
	},
	name: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Tên học vấn không vượt quá 512 ký tự", "Tên học vấn không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập tên học vấn", "Vui lòng nhập tên học vấn")))
			}
			return Promise.resolve()
		}
	},
	user: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value || value.length < 1) {
				return Promise.reject(new Error(t("Vui lòng chọn đối tượng", "Vui lòng chọn đối tượng")))
			}
			return Promise.resolve()
		}
	},
}

  return (
    <>
      <Form layout={"vertical"} form={form} onFinish={onFinish} name="createAcademicLevel" initialValues={{ status : true}}>
				{ loadingForm 
					? 
						<div className="statistic-course-content statistic-course-loading">
							<Spin size="large" />
						</div> 
					: 
						<Row gutter={[16,16]}>
							<Col span={24}>
								<Form.Item name="code" rules={[validations.code]} label={t("Mã học vấn", "Mã học vấn")}>
									<FormInput placeholder={t("Nhập mã học vấn", "Nhập mã học vấn")} />
								</Form.Item>
							</Col>
							<Col span={24}>
								<Form.Item name="name" rules={[validations.name]} label={t("Tên học vấn", "Tên học vấn")}>
									<FormInput placeholder={t("Nhập tên học vấn", "Nhập tên học vấn")} />
								</Form.Item>
							</Col>
						</Row>
				}
			</Form>
    </>
  )
}

export default FormCreateAcademicLevel;